'use client';

import {faWarning} from '@awesome.me/kit-d4c1b300b9/icons/kit/custom';
import type {HTMLChakraProps} from '@chakra-ui/react';
import type {ReactNode} from 'react';
import {forwardRef} from 'react';

import {ChakraDiv, ChakraH4} from '../../utils/chakra-elements';
import {Icon} from '..';

import {useStyles} from './context';

type Props = {
  title?: string | ReactNode;
  img: ReactNode;
  description?: ReactNode;
} & Omit<HTMLChakraProps<'div'>, 'title'>;

export const WidgetError = forwardRef(({title = `Error loading this widget`, img, ...props}: Props, ref) => {
  const {error} = useStyles();
  return (
    <ChakraDiv __css={error} {...props} ref={ref}>
      {img && (
        <ChakraDiv display={`flex`} alignItems={`center`} justifyContent={`center`} w={`space-1000`} h={`space-1000`}>
          {img}
        </ChakraDiv>
      )}
      {typeof title === `string` ? <ChakraH4 flex={1}>{title}</ChakraH4> : title}
    </ChakraDiv>
  );
});

export const DefaultWidgetError = () => (
  <WidgetError
    title={`Error loading this widget`}
    img={<Icon fontSize={`3rem`} width={`3rem`} height={`3rem`} color={`icon.state.warning-bold`} icon={faWarning} />}
  />
);
